import { FocusTrap } from '@farmasiet/frontendcore-reactcomponents';
import classNames from 'classnames';
import * as React from 'react';
import { useEffect } from 'react';

import { getTranslation, keys } from '../../../../../Resources/Translations';
import { NavigationSectionViewModel } from '../../NavigationSectionViewModel.csharp';
import { NavList } from '../NavList';

interface NavListItemProps {
    item: NavigationSectionViewModel;
    className?: string;
    isParentVisible: boolean;
    onClickOutside: () => void;
    setIsSubNavigationOpen?: (value: boolean) => void;
    isFirstLevel?: boolean;
}

export const NavListItem = (props: NavListItemProps) => {
    const [isVisible, setIsVisible] = React.useState(false);
    const hasChildren = !!(props.item.items && props.item.items.length > 0);

    useEffect(() => {
        if (!props.isParentVisible) {
            setIsVisible(false);
        }
    }, [props.isParentVisible]);

    useEffect(() => {
        props.setIsSubNavigationOpen && props.setIsSubNavigationOpen(isVisible);
    }, [isVisible]);

    return (
        <li className={classNames('NavListItem', props.className, isVisible && 'NavListItem--Visible')}>
            <div className={classNames('NavListItem__Heading', props.isFirstLevel && 'NavListItem__Heading--FirstLevel')}>
                {hasChildren && (
                    <button className="NavListItem__Button" onClick={() => setIsVisible(!isVisible)} aria-haspopup="true" aria-expanded={isVisible}>
                        <span className="visuallyHidden">{getTranslation(keys['navigation.open'])}</span>
                    </button>
                )}
                <a
                    href={props.item.url}
                    className={hasChildren ? 'HasSubitems' : undefined}
                    tabIndex={props.item.items && props.item.items.length > 0 ? -1 : undefined}
                >
                    {props.item.name}
                </a>
            </div>

            {hasChildren && (
                <FocusTrap enabled={isVisible}>
                    <div className="NavListItem__Content">
                        <div className="NavListItem__ContentInner">
                            <div className="NavListItem__LinksSections">
                                {props.item.name && (
                                    <button className="NavListItem__BackButton" onClick={() => setIsVisible(false)}>
                                        {props.item.name}
                                    </button>
                                )}

                                <NavList
                                    onClickOutside={props.onClickOutside}
                                    items={props.item.items!}
                                    link={props.item.url}
                                    isParentVisible={isVisible}
                                    onBack={() => setIsVisible(false)}
                                    isFirstLevel={false}
                                />
                            </div>
                        </div>
                    </div>
                </FocusTrap>
            )}
        </li>
    );
};
